export default function HomeIcon({ className }: any) {
  return (
    <svg className={className} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3.66699" y="3.66602" width="5.5" height="5.5" rx="1" stroke="currentColor" strokeLinejoin="round" />
      <rect x="3.66699" y="12.834" width="5.5" height="5.5" rx="1" stroke="currentColor" strokeLinejoin="round" />
      <rect x="12.833" y="12.834" width="5.5" height="5.5" rx="1" stroke="currentColor" strokeLinejoin="round" />
      <rect x="12.833" y="3.66602" width="5.5" height="5.5" rx="1" stroke="currentColor" strokeLinejoin="round" />
    </svg>
  );
}
